import React, { useEffect, useState } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import Navbar from './Navbar'
import List from './MaintanaceTable'
import { fetch_truck_maintanace_list, fetch_all_truck_list } from '../common/action'
import { connect } from 'react-redux'

function App({ fetch_maintanace, fetch_all_trucks, tabType, perms }) {

    useEffect(() => {
        fetch_maintanace(tabType, 1)
        fetch_all_trucks(tabType)
        return () => fetch_maintanace.remove
        
    }, [fetch_maintanace, fetch_all_trucks, tabType])


    const { path } = useRouteMatch()

    const AppMain = () => {
        const [pageLoader, setPageLoader] = useState(false);
        
    const [clearFilterDate, setClearFilterDate] = useState(false)
    const [filterFromDate, setFilterFromDate] = useState({ val : new Date(), status : false})
    const [filterToDate, setFilterToDate] = useState({ val : new Date(), status : false})
    
    const [invokeDate, setInvokeDate]   =   useState(false)

        return (
            <div className="sgr-mntnce-rprt-layout">
                <Navbar tabType={tabType} setPageLoader={setPageLoader} setClearFilterDate={setClearFilterDate} clearFilterDate={clearFilterDate} setFilterFromDate={setFilterFromDate} setFilterToDate={setFilterToDate}
                 filterFromDate={filterFromDate} filterToDate={filterToDate} setInvokeDate={setInvokeDate} invokeDate={invokeDate}/>
                <List tabType={tabType} pageLoader={pageLoader} setPageLoader={setPageLoader}
                 setClearFilterDate={setClearFilterDate} clearFilterDate={clearFilterDate} setFilterFromDate={setFilterFromDate} setFilterToDate={setFilterToDate} perms={perms}
                 filterFromDate={filterFromDate} filterToDate={filterToDate} setInvokeDate={setInvokeDate} invokeDate={invokeDate}/>
            </div>
        )
    }

    return (
       <Switch>
           <Route path={path} component={AppMain} />
       </Switch>
    )
}

const mapStateToProps = () => {
    return { }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetch_maintanace: (tab, page) => dispatch(fetch_truck_maintanace_list(tab, page)),
        fetch_all_trucks: (tab) => dispatch(fetch_all_truck_list(tab))
      }
}

export default connect(mapStateToProps, mapDispatchToProps) (App)
